import React from 'react';
import {
  Control,
  Controller,
  FieldValues,
  get,
  Path,
  PathValue,
  useFormState,
} from 'react-hook-form';
import clsx from 'clsx';
import ControllerDropZone from '../ui/ControllerDropZone';

interface StyledInputProps<FieldsType extends FieldValues> {
  title?: string;
  name: Path<FieldsType>;
  control: Control<FieldsType>;
  defaultValue?: PathValue<FieldsType, Path<FieldsType>>;
  className?: React.HTMLAttributes<HTMLDivElement>['className'];
  placeholder?: string;
  multiple?: boolean;
  accept?: string;
  disabled?: boolean;
}

const StyledDropZone = <FieldsType extends FieldValues>({
  title,
  control,
  name,
  defaultValue,
  className,
  placeholder,
  multiple = false,
  accept = 'image/png, image/jpeg, image/webp',
  disabled = false,
}: StyledInputProps<FieldsType>) => {
  const { errors } = useFormState({ control });
  const errorMessage = get(errors, name + '.message') as unknown as string;

  return (
    <div className={clsx('flex flex-col w-full gap-1.5', className)}>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <ControllerDropZone
            field={{
              ...field,
              onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
                if (event === undefined) {
                  return field.onChange(null);
                }
                const files = event.target.files;
                if (!files) return;

                field.onChange(
                  multiple ? Array.from(files).slice(0, 50) : files[0],
                );
              },
            }}
            disabled={disabled}
            title={title}
            name={name}
            placeholder={placeholder}
            multiple={multiple}
            accept={accept}
          />
        )}
        defaultValue={defaultValue}
      />
      {errorMessage !== '' && (
        <p className="text-sm leading-6 font-medium text-error-500">
          {errorMessage}
        </p>
      )}
    </div>
  );
};

export default StyledDropZone;
